import React from "react";
import { withTranslation } from 'react-i18next'
// import { Checkout } from "./Checkout";

import { initializePaddle, Paddle } from '@paddle/paddle-js';



class CardForm extends React.Component {

    state = { Paddle: null };
    Paddlex = null;

    componentDidMount() {

        initializePaddle({
            environment: 'sandbox',
            token: 'live_8d4a12006b626a93275acaa1f9e',

            checkout: {
                settings: {
                    //       displayMode: "inline",
                    //     theme: "light",
                    locale: "ar",
                    frameTarget: "checkout-container",
                    //      frameInitialHeight: "450",
                    //      frameStyle: "width: 100%; min-width: 312px; background-color: transparent; border: none;"
                }
            },
            eventCallback: function (data) {
                console.log("ss", data);
            }
        }).then(
            (paddleInstance: Paddle | undefined) => {
                if (paddleInstance) {
                    console.log(paddleInstance.Checkout);
                    this.Paddlex = paddleInstance;
                    this.setState({
                        Checkout: paddleInstance
                    });

                    paddleInstance.Checkout.open({
                        items: [{ priceId: 'pri_01hv16p6ggcha1c10qreeg7117', quantity: 1 }],
                        customer: {
                            email: 'yousef.zammar@gmail.com'
                        }
                    });
                }
            },
        );
    }

    renderField = ({
        input,
        title,
        type,
        placeholder,
        required,
        className,
        style,
        meta: { touched, error }
    }) => (
        <>
            <input {...input} title={title} placeholder={placeholder} style={style} required={required} type={type} autoComplete="off" spellCheck={false} className={`${className} ${(touched && error) ? 'is-invalid' : ''}`} />
            {touched && error && <div className="invalid-feedback">{this.props.t(error)}</div>}
        </>
    );

    checkout = () => {

    }

    render() {
        const { t } = this.props;

        return (
            <>
                <div className="contact-form-area">

                    <h4 className="title d-flex justify-content-center align-items-center">
                        <i className="icon fa-solid fa-credit-card px-1 text-primary"></i>
                        {t("Pages.Register.steps.CardForm")}
                    </h4>

                    <div className={`contact-form p-3 w-100 mb-4 inner-box p-3 pt-4 text-center `} style={{
                        background: 'rgb(170 233 255)',
                        border: '1px solid rgb(0 191 255)',
                        borderRadius: '10px'
                    }}  >
                        <div className="text-center w-100">
                            <h4 className="title mb-3">
                                صِفْر مَخاطِر
                            </h4>
                            يُمْكِنك إِلغَاء الاشْتراك بِبضْع نَقَرات فِي أيِّ وَقْت تُريد خِلَال الشَّهْر الأوَّل ولن تَدفَع شيْئًا .
                        </div>
                    </div>


                    <div className="contact-form" >

                        <div className="checkout-container w-100 pb-4"></div>

                        <div className="form-group w-100 text-center d-flex justify-content-around align-items-center">
                            <button type="button" className={`custom-button danger-button `} onClick={() => this.props.goBack()} >
                                <span className="d-flex justify-content-center align-items-center">
                                    <i className="icon fad fa-arrow-right px-1"></i>
                                    {t('Pages.Register.Previous')}
                                </span>
                            </button>

                            <button type="button" className={`custom-button secondary-button `} onClick={this.checkout} >
                                <span className="d-flex justify-content-center align-items-center">
                                    {t('Pages.Register.Next')}
                                    <i className="icon fad fa-arrow-left px-1"></i>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default withTranslation('common')(CardForm);